import { useWorkspaceDetails } from "@api/workspace.api";
import { useCurrentUserIsWorkspaceOrganizationMember } from "@hooks/useCurrentUserIsWorkspaceOrganizationMember";
import { useScope } from "@state/scopeContext.lib";
import {
    getWorkspaceTaskListCapabilities,
    TaskListCapabilities,
} from "./taskListCapabilities";

/** The workspace Tasks page's capabilities for the current user, including the firm-member filters and client views. */
export const useWorkspaceTaskListCapabilities = (): TaskListCapabilities => {
    const { workspaceId } = useScope();
    const { isLoading: isLoadingMembership } = useWorkspaceDetails(workspaceId);
    const { isOrganizationMember } =
        useCurrentUserIsWorkspaceOrganizationMember();
    return getWorkspaceTaskListCapabilities({
        isOrganizationMember,
        isLoadingMembership,
    });
};
